import { createContext, useContext } from 'react'

interface WorkSpaceContextValue {
  onDeleted?: () => void
}

export const WorkSpaceContext = createContext<WorkSpaceContextValue | undefined>(undefined)

export const useWorkSpaceContext = () => {
  const ctx = useContext(WorkSpaceContext)
  if (!ctx) throw new Error('useWorkSpaceContext must be used within a WorkSpaceProvider')
  return ctx
}
